import React from "react";
import LoadingSpinner from "../LoadingSpinner";
import { UserContext } from "../../lib/context";

class NorandMonoMK2ProductCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
    };
  }

  static contextType = UserContext;

  orderNow = async (event) => {
    event.preventDefault();
    this.setState({ loading: true });
    console.log(this.context.psu);
    this.redirectToCheckout = true;

    try {
      // Use the new Cart API with GraphQL mutation instead of deprecated checkout API
      const variantId = (this.context.psu === 0) ? "gid://shopify/ProductVariant/50760275951947" : // EU
        (this.context.psu === 1) ? "gid://shopify/ProductVariant/50760275951947" : // US
        "gid://shopify/ProductVariant/50760275951947"; // UK

      const query = `
        mutation cartCreate($input: CartInput!) {
          cartCreate(input: $input) {
            cart {
              id
              checkoutUrl
            }
            userErrors {
              field
              message
            }
          }
        }
      `;

      const variables = {
        input: {
          lines: [{ quantity: 1, merchandiseId: variantId }],
          discountCodes: ["MONOBF2025"]
        }
      };

      const response = await fetch(`https://embodme-norand.myshopify.com/api/2024-04/graphql.json`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': 'c715561b4f24fbaeb3555426faa361c9'
        },
        body: JSON.stringify({ query, variables })
      });

      const data = await response.json();
      
      if (data.data && data.data.cartCreate && data.data.cartCreate.cart) {
        const checkoutUrl = data.data.cartCreate.cart.checkoutUrl;
        if (checkoutUrl) {
          const urlWithDiscount = checkoutUrl + (checkoutUrl.includes('?') ? '&' : '?') + 'discount=MONOBF2025';
          window.location.href = urlWithDiscount;
        } else {
          console.error('No checkout URL returned');
          this.setState({ loading: false });
        }
      } else {
        console.error('Cart creation failed:', (data.data && data.data.cartCreate && data.data.cartCreate.userErrors) || data.errors);
        this.setState({ loading: false });
      }
    } catch (error) {
      console.error('Error creating cart:', error);
      this.setState({ loading: false });
    }
  };
  render() {
    return (
      <>
        {this.state.loading && <LoadingSpinner />}
        <div className="creativityMonoContainer">
          <div className="backdrop-blur">
            <div className="anim-bg">
              <div className="anim-form-1"></div>
              <div className="anim-form-2"></div>
              <div className="anim-form-3"></div>
              <div className="anim-form-4"></div>
              <div className="anim-form-5"></div>
              <div className="anim-form-6"></div>
              <div className="anim-form-7"></div>
            </div>
          </div>
          <div className="mainCreativity">
            <p className="p1Creativity">{this.props.mainText}</p>
            <p className="headerCreativityNorand">
              {this.props.NORANDTxt}
              <span className="headerCreativityMono">{this.props.MONO} </span>
              <span className="headerCreativityMonoMK2">{this.props.MK2} </span>
            </p>
            <img src={this.props.picCut} alt="" className="cutMonoImgMK2" />

            {/* MK2 no longer sold: button disabled, checkout removed.
            <button onClick={this.orderNow} className="btnOrderNow">
                {this.props.btnText}
                <UserContext.Consumer>
                  {(context) => (context.priceInEur ? " €589" : " $589")}
                </UserContext.Consumer> */}
            <button className="btnOrderNow" disabled>
                Out of stock
              </button>
          </div>
        </div>
      </>
    );
  }
}

export default NorandMonoMK2ProductCard;
